import { render, staticRenderFns } from "./CardTarjaTwitterPapoDeSegunda.vue?vue&type=template&id=5a01edbe&scoped=true"
import script from "./CardTarjaTwitterPapoDeSegunda.vue?vue&type=script&lang=js"
export * from "./CardTarjaTwitterPapoDeSegunda.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaTwitterPapoDeSegunda.vue?vue&type=style&index=0&id=5a01edbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01edbe",
  null
  
)

export default component.exports